var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show && _setup.tableName
    ? _c(
        "button",
        {
          staticClass: "btn btn-sm btn-light text-start",
          attrs: { type: "button" },
          on: { click: _setup.selectCategory },
        },
        [
          !_vm.item.value ? _c("span", [_vm._v("select")]) : _vm._e(),
          _vm._v(" "),
          _setup.itemId
            ? _c(_setup.FormControlCategoryTitle, {
                attrs: { "table-name": _setup.tableName, id: _setup.itemId },
              })
            : _vm._e(),
        ],
        1
      )
    : _setup.show && !_setup.componentId
    ? _c(
        "small",
        { staticClass: "text-danger form-text ms-2 mb-1 fst-italic small" },
        [_vm._v("\n    Error: No collection targeted\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }